import { Link } from 'react-router-dom';

export default function Forbidden({ permission }) {
  const label = Array.isArray(permission) ? permission.join(' or ') : permission;

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4">
      <div className="h-14 w-14 rounded-full bg-primary-50 text-primary flex items-center justify-center text-2xl font-bold mb-4">
        !
      </div>
      <h1 className="text-xl font-semibold text-gray-900 mb-2">Access denied</h1>
      <p className="text-gray-500 max-w-sm">
        {permission ? (
          <>
            You need permission: <span className="font-mono text-gray-700">{label}</span> — contact an
            administrator.
          </>
        ) : (
          'You do not have permission to view this page — contact an administrator.'
        )}
      </p>
      <Link to="/" className="mt-6 text-primary font-medium hover:underline">
        Back to dashboard
      </Link>
    </div>
  );
}
